"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importDefault(require("react"));

var editable_image_explanation_option_view_component_1 = require("../editable-image-explanation-option-view/editable-image-explanation-option-view.component");

var image_explanation_option_view_styles_1 = require("../image-explanation-option-view/image-explanation-option-view.styles");

var editable_image_explanation_option_view_styles_1 = require("../editable-image-explanation-option-view/editable-image-explanation-option-view.styles");

var variable_text_editor_container_1 = __importDefault(require("../variable-text-editor/variable-text-editor.container"));

var edit_explanation_option_view_styles_1 = require("./edit-explanation-option-view.styles");

var EditExplanationOptionView = function EditExplanationOptionView(_ref) {
  var imageUrl = _ref.imageUrl,
      imageName = _ref.imageName,
      onSave = _ref.onSave,
      onCancel = _ref.onCancel,
      design = _ref.design;
  var bodyBackColor = design.bodyBackColor,
      bodyTextColor = design.bodyTextColor;
  return react_1.default.createElement(editable_image_explanation_option_view_styles_1.StyledEditableImageExpOptionWrapperDiv, {
    "data-meta": "image-explanation-option",
    backgroundColor: bodyBackColor
  }, react_1.default.createElement(editable_image_explanation_option_view_styles_1.StyledEditableImageExpOptionImageDiv, {
    imageUrl: imageUrl
  }), react_1.default.createElement(editable_image_explanation_option_view_styles_1.StyledEditableImageExpOptionBodyDiv, {
    color: bodyTextColor
  }, react_1.default.createElement(image_explanation_option_view_styles_1.StyledImageNameH2, null, imageName), react_1.default.createElement(edit_explanation_option_view_styles_1.StyledEditorWrapperDiv, null, react_1.default.createElement(variable_text_editor_container_1.default, {
    rawText: "",
    onSave: onSave,
    onOverlayClick: onCancel,
    validate: editable_image_explanation_option_view_component_1.isValidExplanation
  }))));
};

exports.default = EditExplanationOptionView;